export const referalDocumentUploadTranslations = {
    en: {
        documentType: "Document Type *",
        selectDocumentType: "Select Document Type",
        prescription: "Prescription",
        report: "Report",
        lenseReport: "Lense Report",
        other: "Other",
        remark: "Remark *",
        dropFilesHere: "Drop the files here...",
        clickOrDragToUpload: "Click or drag to upload",
        allowedFilesCaption: "(Only PDF, JPG, and PNG up to 5MB)",
        file: "File",
        size: "Size",
        uploading: "Uploading...",
        submit: "Submit",
    },
    mr: {
        documentType: "कागदपत्र प्रकार *",
        selectDocumentType: "कागदपत्र प्रकार निवडा",
        prescription: "प्रिस्क्रिप्शन",
        report: "अहवाल",
        lenseReport: "लेन्स अहवाल",
        other: "इतर",
        remark: "टिप्पणी *",
        dropFilesHere: "फायली येथे ड्रॉप करा...",
        clickOrDragToUpload: "अपलोड करण्यासाठी क्लिक किंवा ड्रॅग करा",
        allowedFilesCaption: "(फक्त PDF, JPG, PNG कमाल 5MB)",
        file: "फाइल",
        size: "आकार",
        uploading: "अपलोड होत आहे...",
        submit: "सबमिट करा",
    },
};
